import React from 'react';
import { Container, Segment } from 'semantic-ui-react';
import { fireGoogleAnalyticsPageView } from '../../utils/CommonUtil';
import { googleAnalyticsUrls } from '../../utils/Constants';

export const USER_CREATED_EMAIL_SENT = (
  <Container className='main-content'>
    <Segment>
      <h3>Request Submitted</h3>
      <p>
        You have completed the first step in creating your account. We have sent
        a verification email to the address provided. Click the link provided in
        the email to finalize your account.
      </p>
    </Segment>
  </Container>
);

export const USER_EXISTING_EMAIL_SENT_TO_REGISTER_FOR_ERL = (
  <Container className='main-content'>
    <Segment>
      <h3>Response Summary</h3>
      <p>
        We have found your existing Mutual of Omaha account in our records under
        the same email address. However, the account associated with this email
        was not previously authorized. Authorization has now been granted.
      </p>
      <a href='../redirectToClaimsUi'>
        <u>Click here</u>
        {' '}
      </a>
      to login with your existing credential, update your password or unlock
      your account.
    </Segment>
  </Container>
);

export const USER_EXISTING_WITH_ERL_ACCESS_PROMPT_USER_TO_LOGIN = (
  <Container className='main-content'>
    <Segment>
      <h3>Response Summary</h3>
      <p>
        <strong>
          It appears you already have an account with Mutual of Omaha or your
          email already being used by a different account.
        </strong>
      </p>
      <a href='../redirectToClaimsUi'>
        <u>Click here</u>
        {' '}
      </a>
      to login with your existing credential, update your password or unlock
      your account.
    </Segment>
  </Container>
);

export const SERVER_ERROR_TRY_AGAIN_LATER = (
  <Container className='main-content'>
    <Segment>
      <h3>Request Processing Failed...</h3>
      <p>
        The server encountered an error processing the request. Please try again
        later by reloading the web page and filling the details from the
        beginning.
      </p>
    </Segment>
  </Container>
);

const getModalContentFromRegistrationResponseStatusCode = (statusCode) => {
  switch (statusCode) {
    case 201:
      fireGoogleAnalyticsPageView(googleAnalyticsUrls.regSuccess);
      return USER_CREATED_EMAIL_SENT;
    case 401:
      fireGoogleAnalyticsPageView(googleAnalyticsUrls.userExistEmail);
      return USER_EXISTING_EMAIL_SENT_TO_REGISTER_FOR_ERL;
    case 409:
      fireGoogleAnalyticsPageView(googleAnalyticsUrls.userExistPromptLogin);
      return USER_EXISTING_WITH_ERL_ACCESS_PROMPT_USER_TO_LOGIN;
    default:
      fireGoogleAnalyticsPageView(googleAnalyticsUrls.regFailed);
      return SERVER_ERROR_TRY_AGAIN_LATER;
  }
};

export default getModalContentFromRegistrationResponseStatusCode;
